<div class="row">
	<div class="col-12">
	  <div class="content-header">Attendence Form</div>
	</div>
  </div>
  <!-- Basic Inputs start -->
  <section id="basic-input">
	<div class="row">
	  <div class="col-12">
		<div class="card">
		  <!-- <div class="card-header">
					  <h4 class="card-title">Basic</h4>
				  </div> -->
		  <div class="card-content">
			<div class="card-body">
			  <div class="row">
				<div class="col-md">
				  <form [formGroup]="attendenceForm">
					<fieldset class="form-group" *ngIf="user_role?.roles =='admin'">
						<label>User</label>
						<ng-select
						  [items]="emp_list"
						  bindLabel="name"
						  bindValue="_id"
						  [closeOnSelect]="false"
						  placeholder="Select user"
						  [(ngModel)]="selected_emp"
						  [ngModelOptions]="{ standalone: true }"
						  (change)="getEmpId($event)"
						>
						</ng-select>
					  </fieldset>
					<fieldset class="form-group">
					  <label>Start Time</label>
					  <input
						type="time"
						class="form-control"
						[formControl]="startTime" [(ngModel)]="model.startTime"
						id="startTime"
						placeholder="Enter start time"
					  />
					
					</fieldset>
					<fieldset class="form-group">
						<label>End Time</label>
						<input
						  type="time"
						  class="form-control"
						  [formControl]="endTime" [(ngModel)]="model.endTime"  
						  id="endTime"
						  placeholder="Enter end time" 
						/>
					</fieldset>
					<fieldset class="form-group">
						<label>Working Hours</label>
						<input
						  type="text"
						  class="form-control"
						  [(ngModel)]="timeDiff" [ngModelOptions]="{standalone: true}"
						  placeholder="Enter Work Hours"
						/>
					</fieldset>
					<fieldset class="form-group">
						<label>Attendance Date</label>
						<input
						  type="date"
						  class="form-control"
						  formControlName="attendanceDate"
						  [ngModel]="model.attendanceDate | date: 'yyyy-MM-dd'"
						  [disabled]="false"
						  id="attendanceDate"
						/>
					</fieldset>
										
					  <fieldset class="form-group"  *ngIf="user_role?.roles =='admin'">
						<label>Status</label>
						<ng-select
						  [items]="status_list"
						  bindLabel="displayname"
						  bindValue="_id"
						  [closeOnSelect]="false"
						  placeholder="Select status"
						  [(ngModel)]="selected_status"
						  [ngModelOptions]="{ standalone: true }"
						  (change)="getStatusId($event)"
						>
						</ng-select>
					  </fieldset>
					
				  </form>
				</div>
				<div class="col-md">
				  <form [formGroup]="attendenceForm">
					<fieldset class="form-group" *ngIf="user_role?.roles =='admin'">
						<label>Verified</label>
						<ng-select
						  [items]="verified_list"
						  bindLabel="name"
						  bindValue="_id"
						  [closeOnSelect]="false"
						  placeholder="Select one"
						  [(ngModel)]="selected_verified"
						  [ngModelOptions]="{ standalone: true }"
						  (change)="getVerifiedId($event)"
						>
						</ng-select>
					  </fieldset>
					
					
					  <fieldset class="form-group" *ngIf="user_role?.roles !='admin'">
						<label>Status</label>
						<ng-select
						  [items]="status_list"
						  bindLabel="displayname"
						  bindValue="_id"
						  [closeOnSelect]="false"
						  placeholder="Select status"
						  [(ngModel)]="selected_status"
						  [ngModelOptions]="{ standalone: true }"
						  (change)="getStatusId($event)"
						>
						</ng-select>
					  </fieldset>
					
					  <fieldset class="form-group">
						<label>Task</label>
						<textarea
						  formControlName="task" [(ngModel)]="model.task"
						  id="hidden-label-form-6"
						  rows="3"
						  class="form-control"
						  name="comment2"
						  placeholder="Enter task"
						></textarea>
					  </fieldset>
					<fieldset class="form-group" *ngIf="user_role?.roles =='admin'">
					  <label>notes</label>
					  <textarea
						formControlName="notes" [(ngModel)]="model.notes"
						id="hidden-label-form-6"
						rows="3"
						class="form-control"
						name="comment2"
						placeholder="Enter notes"
					  ></textarea>
					</fieldset>
					<fieldset class="form-group" *ngIf="user_role?.roles =='admin'">
						<label>Admin Notes</label>
						<textarea
						  formControlName="admin_notes" [(ngModel)]="model.admin_notes"
						  id="hidden-label-form-6"
						  rows="4"
						  class="form-control"
						  name="comment2"
						  placeholder="Enter admin notes"
						></textarea>
					  </fieldset>
					<div
					  class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-3 mt-sm-2"
					>
					  <button
						type="submit"
						class="btn btn-primary mb-2 mb-sm-0 mr-sm-2"
						(click)="submit()"
					  >
						Submit
					  </button>
					  <button
						type="reset"
						class="btn btn-secondary"
						onclick="history.back()"
					  >
						Cancel
					  </button>
					</div>
				  </form>
				</div>
			  </div>
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  